import React, { PureComponent } from "react";
import "./PlatformWiseAnalysis.scss";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export default class PlatformWiseAnalysis extends PureComponent {
    constructor(props) {
        super(props);
    }
    chartData() {
        let rawData = this.props.platformWiseData || [];
        let allplatform = [];
        let chartData = rawData.map((ele) => {
            allplatform.push(ele["platforms.platform_group"]["buckets"]);
        });
        let faltendArray = allplatform.flat();
        let result = [];
        faltendArray.forEach(function (ele) {
            if (!this[ele.key]) {
                this[ele.key] = { key: ele.key, doc_count: 0 };
                result.push(this[ele.key]);
            }
            this[ele.key].doc_count += ele.doc_count;
        }, Object.create(null));
        let finalResult = result.map((ele) => {
            let obj = {};
            obj["y"] = ele.doc_count;
            if (ele.key === "fbcomment") {
                obj["name"] = "Facebook Comments";
            } else {
                obj["name"] = ele.key;
            }
            return obj;
        });
        return finalResult;
    }
    options = {
        chart: {
            type: "pie",
            className: "skiptranslate",
        },
        title: {
            text: "Platformwise Analysis",
            style: {
                fontFamily: "'Roboto', sans-serif",
                textTransform: "normal",
                fontSize: "14px",
            },
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: "pointer",
                dataLabels: {
                    enabled: false,
                },
                showInLegend: true,
            },
        },
        credits: {
            enabled: false,
        },
        legend: {
            itemStyle: {
                fontFamily: "'Roboto', sans-serif",
                textTransform: "capitalize ",
            },
            alignColumns: false,
        },
        lang: {
            noData: "No data.",
        },
        noData: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                color: "#303030",
            },
            position: {
                align: "center",
            },
        },
        tooltip: {
            valueSuffix: "%",
            style: {
                fontFamily: "'Roboto', sans-serif",
                textTransform: "capitalize ",
            },
            formatter: function () {
                return `<b>${this.point.name} : ${this.y} posts, (${this.point.percentage.toFixed(1) + "%"})</b>`;
            },
        },
        series: [
            {
                data: this.chartData(),
                // innerSize: "60%",
            },
        ],
    };
    render() {
        return (
            <div className="platformWiseAnalysis">
                <div className="platformwise-media-analysis-item">
                    <HighchartsReact highcharts={Highcharts} options={this.options} className="pie-chart" />
                </div>
            </div>
        );
    }
}
